module.exports = __webpack_public_path__ + "media/packs/images/small-container-245649688deb2c66ececd1256541cb58.svg";